import React, { Fragment, ReactNode } from 'react';
import SideAds from '../../components/sideAds';

interface Props {
  posts: any[];
  render: (n: any) => ReactNode;
  adverts: KeyedAdverts;
}

const PostsWithAdverts = ({ posts, adverts, render }: Props) => {
  const first = posts.slice(0, 5);
  const second = posts.slice(5);
  return (
    <>
      {first.map((p, idx) => (
        <Fragment key={idx}>{render(p)}</Fragment>
      ))}
      <div className='grid grid-cols-2 md:hidden'>
        <SideAds preventViewEvents={true} adverts={adverts} />
      </div>
      {second.map((p, idx) => (
        <Fragment key={idx}>{render(p)}</Fragment>
      ))}
    </>
  );
};

export default PostsWithAdverts;
